export const PATHS = {
  HOME: '/',
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  COMPLAINTS: '/complaints',
  NEAREST_LOCATION: '/nearest-location',
  TECHNICIAN_MAP: '/technician-map',
}